import { render, staticRenderFns } from "./sensoryCalibrationDetail.vue?vue&type=template&id=6027a65f"
import script from "./sensoryCalibrationDetail.vue?vue&type=script&lang=js"
export * from "./sensoryCalibrationDetail.vue?vue&type=script&lang=js"
import style0 from "./sensoryCalibrationDetail.vue?vue&type=style&index=0&id=6027a65f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6027a65f')) {
      api.createRecord('6027a65f', component.options)
    } else {
      api.reload('6027a65f', component.options)
    }
    module.hot.accept("./sensoryCalibrationDetail.vue?vue&type=template&id=6027a65f", function () {
      api.rerender('6027a65f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-calibration/sensoryCalibrationDetail.vue"
export default component.exports